import useInterval from 'app/core/hooks/useInterval';
import { usePageVisibility } from 'app/core/hooks/usePageVisibility';
import { checkUnreadThreadsMessages } from 'app/store/messaging';
import { RootState } from 'app/store/rootReducer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const POLLING_DELAY = 60000;

export default function FetchThreads() {
  const dispatch = useDispatch();

  const { isMessagingPageOn } = useSelector(
    (state: RootState) => state.messaging
  );

  const { user } = useSelector((state: RootState) => state.auth);

  const [delay, setDelay] = useState<number | null>(null);

  const isVisible = usePageVisibility();

  useEffect(() => {
    if (user) {
      dispatch(checkUnreadThreadsMessages());
    }
  }, [user]);

  useEffect(() => {
    if (isMessagingPageOn || !user || !isVisible) {
      setDelay(null);
    } else {
      setDelay(POLLING_DELAY);
    }
  }, [isMessagingPageOn, user, isVisible]);

  useInterval(() => {
    dispatch(checkUnreadThreadsMessages());
  }, delay);

  return null;
}
